

































import {
  Vue, Component, Prop
} from "@/shared/vuepack";
import { formatMMddyyyyDateString } from "@/shared/dateString";
import Widget from "@/shared/components/Widget.vue";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";

@Component({
  components: { Widget },
})
export default class HsabExpenseCardRowInformationRequest extends Vue {
  formatMMddyyyyDateString = formatMMddyyyyDateString;
  hsabExpenseFormStore = useHsabExpenseFormStore();

  get expense () {
    return this.hsabExpenseFormStore.expense;
  }
  get hasInformationRequests (): boolean {
    return this.hsabExpenseFormStore.hasExpense
        && this.expense.reimbursement
        && this.expense.reimbursement.informationRequests
        && this.expense.reimbursement.informationRequests.length > 0;
  }
}
